import { type FC } from "react";

import { Card, CardRowSimple, type GridCard, Tag, TimeAgo } from "widgets";

import { type Marker } from "../../../graphql.js";

export interface IMarkerCardProps extends GridCard {
  marker: Marker;
}

const MarkerDetailsCard: FC<IMarkerCardProps> = ({ marker }) => {
  if (!marker) {
    return null;
  }

  return (
    <Card key="marker-info-card" title={"Details"}>
      <CardRowSimple label={"Creation date"}>
        <TimeAgo dateTimeISO={marker.created} />
      </CardRowSimple>
      {marker.modified && (
        <CardRowSimple label={"Modified"}>
          <TimeAgo dateTimeISO={marker.modified} />
        </CardRowSimple>
      )}
      <CardRowSimple label={"Owner"}>{marker.owner}</CardRowSimple>
      <CardRowSimple label={"Status"}>
        <Tag label={marker.markerStatus.name} />
      </CardRowSimple>
    </Card>
  );
};

export { MarkerDetailsCard };
